import React from 'react'
import { Modal, Button, SplitButton, Dropdown } from 'react-bootstrap'
import * as Yup from 'yup'

interface StartLayoutButtonProps {
  fetching: boolean
  handleSubmit: () => void
  setFieldValue: (field: string, value: unknown) => void
}

const StartLayoutButton = ({ fetching, handleSubmit, setFieldValue }: StartLayoutButtonProps) => (
  <SplitButton variant='primary' title='実行する' type='submit' onClick={handleSubmit} disabled={fetching}>
    <Dropdown.Item
      onClick={(_: React.MouseEvent) => {
        console.log('menu clicked!')
        setFieldValue('quickLayout', false)
        handleSubmit()
      }}
    >
      割り付けを実行する(3分)
    </Dropdown.Item>
  </SplitButton>
)

interface StartLayoutFormProps {
  layoutableName: string
  onClickCancel: () => void
  handleSubmit: () => void
  fetching: boolean
  setFieldValue: (field: string, value: unknown) => void
}

const StartLayoutFormBase = ({ layoutableName, onClickCancel, handleSubmit, ...props }: StartLayoutFormProps) => {
  return (
    <>
      <Modal.Header>
        <Modal.Title>割り付け実行</Modal.Title>
      </Modal.Header>
      <Modal.Body>{layoutableName}の割り付けを実行しますか?</Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onClickCancel}>
          キャンセル
        </Button>
        <StartLayoutButton {...{ handleSubmit }} {...props} />
      </Modal.Footer>
    </>
  )
}

export const StartLayoutForm = Object.assign(StartLayoutFormBase, {
  schema: Yup.object().shape({
    quickLayout: Yup.boolean()
  })
})
